import React from "react";
import useStyles from "@hooks/useStyles";

import Grid from "@material-ui/core/Grid";

import useStores from "@hooks/useStores";
import ProLeadList from "./ProLeadList";

const LeadListing = ({ job }) => {
	const classes = useStyles("Pro");
	const { proStore: store } = useStores();

	return (
		<React.Fragment>
			<Grid container spacing={6}>
				<ProLeadList leads={store.recentActiveLeads?.items} job={job} />
			</Grid>
		</React.Fragment>
	);
};

LeadListing.propTypes = {};
export default LeadListing;
